export default __webpack_public_path__ + "static/media/9.3994afb0.png";